import {StyledGrid} from 'presentation/components';
import {DataContentCard} from 'presentation/pages/private/my-hospitalization/components/DataContentCard';
import {translations} from 'presentation/translations-new';
import {textHandle} from 'presentation/utils/textHandle';
import React from 'react';
import {StyledCardContainer, StyledCardContent, StyledCardHeader} from './styles';
import {PatientDataCardType, type InfoListType} from './types';

const {card} = translations['pt-br'].privateFlow.myHospitalization.patientData;

const ICON_SIZE_DEFAULT = 20;

export const PatientDataCard = ({patient}: PatientDataCardType) => {
	const infoList: InfoListType[] = [
		{
			iconName: 'cake-outlined',
			title: card.birthday,
			description: patient.birthDate,
			iconSize: ICON_SIZE_DEFAULT,
		},
		{
			iconName: 'hapvida-logo',
			title: card.wallet,
			description: patient.wallet,
			iconSize: ICON_SIZE_DEFAULT,
		},
		{
			iconName: 'assignment-outline',
			title: card.service,
			description: patient.serviceCode.toString(),
			iconSize: ICON_SIZE_DEFAULT,
		},
		{
			iconName: 'hospital-hapvida-outlined',
			title: card.hospital,
			description: patient.legalProviderName,
		},
		{
			iconName: 'shield-health-outlined',
			title: card.position,
			description: patient.stationName,
			iconSize: ICON_SIZE_DEFAULT,
		},
		{
			iconName: 'hotel-bed-line',
			title: card.bed,
			description: patient.bedName,
			iconSize: ICON_SIZE_DEFAULT,
		},
	];

	return (
		<StyledCardContainer>
			<StyledCardHeader variant="h6">
				{textHandle(patient.patientName.toLowerCase()).capitalize()}
			</StyledCardHeader>
			<StyledCardContent>
				<StyledGrid.Root spacing={2}>
					{infoList.map(info => (
						<StyledGrid.Item key={info.title} xs={12} sm={12} md={12} lg={4} xl={4}>
							<DataContentCard
								iconName={info.iconName}
								title={info.title}
								description={info.description}
								iconSize={info.iconSize}
							/>
						</StyledGrid.Item>
					))}
				</StyledGrid.Root>
				<DataContentCard
					iconName="credit-card-checked"
					title={card.plan}
					description={patient.plan}
					iconSize={ICON_SIZE_DEFAULT}
				/>
			</StyledCardContent>
		</StyledCardContainer>
	);
};
